import styled, { css, keyframes } from 'styled-components';
import { pxToRem } from 'modules/spacing';
import { theme } from 'modules/tetrisTheme';
const overlayFadeIn = keyframes ` 
  from {
    background-color: transparent;
    /* without opacity the animation is not smooth */
    backdrop-filter: blur(${pxToRem(1.5)}) opacity(0);
  } 
  to {
    background-color: color-mix(in srgb, ${theme.semantic.surface.sunken}, transparent 76%);
    backdrop-filter: blur(${pxToRem(1.5)}) opacity(1);
  }
`;
export const Container = styled.div `
  overflow-y: auto;
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  height: -webkit-fill-available; /* webkit hack */
  ${(props) => props.$overlay &&
    css `
      animation: 0.2s ${overlayFadeIn} forwards;
    `};
`;
